import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import  * as moment  from 'moment';

@Component({
    selector: 'modal-recurrency',
    templateUrl: '../../templates/partials/modal-recurrency.html'
})

export class ModalRecurrencyComponent implements OnInit {
    @Input() showModal;
    @ViewChild('recurrencyModal') public recurrencyModal:ModalDirective;
    @Output() emitCloseModal = new EventEmitter();
    @Input() modalData;
    public showFeeDisclaimer = true;
    public allowToPenalize = false;
    public modalInfo = {
        headerText: null,
        bodyText: null,
        buttonR: false,
        disableBtn: false
    }
    constructor() { }

    public onHidden():void {
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public closeModal():void{
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public modifyAllServices() {
        this.modalInfo["disableBtn"] = true;
        this.modalData["options"] = {allServices: true}
        let penalize = this.getPenalized();
        this.emitCloseModal.emit({action:"close", data: this.modalData, penalized: penalize});
    }

    public modifyService() {
        this.modalInfo["disableBtn"] = true;
        let penalize = this.getPenalized();
        if(this.modalData["old_service"]["periodicity"] == "none" && this.modalData["new_service"]["periodicity"] != "none"){
            this.modalData["options"] = {allServices: true}
        }else{
            this.modalData["options"] = {allServices: false}
        }
        this.emitCloseModal.emit({action:"close", data: this.modalData, penalized: penalize});
    }

    ngOnChanges($changes) {
        
        if(this.modalData != null) {
            (this.modalData["old_service"]["periodicity"] == "none") 
            ? this.setTextsPuntual()
            : this.setTextsRecurrent() 

            this.showDisclaimer();
            this.modalInfo["disableBtn"] = false;
        }
        (this.showModal) ? this.recurrencyModal.show() : this.recurrencyModal.hide();
    }

    private setTextsPuntual() {
        this.modalInfo["headerText"] = "Modificar servicio puntual";
        this.modalInfo["bodyText"] = "¿Seguro que quieres modificar este servicio?";
    }

    private setTextsRecurrent() {
        this.modalInfo["headerText"] = "Modificar servicio recurrente";
        this.modalInfo["bodyText"] = "¿Quieres modificar este servicio o este y todos los futuros?";
        this.modalInfo["buttonR"] = true;
    }

    private getPenalized() {
        let penalize;
        if(this.showFeeDisclaimer) penalize = (this.allowToPenalize) ? 1 : 0;
        else penalize = null;
        return penalize;
    }

    private showDisclaimer() {
        let today = moment().format("YYYY-MM-DD HH:mm");
        let dateService = this.modalData["old_service"]["date"] + " " + this.modalData["old_service"]["time_ini"];
        dateService = moment(dateService, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm");
        
        var duration = moment(dateService, "YYYY-MM-DD HH:mm").diff(moment(today, "YYYY-MM-DD HH:mm"), 'minutes');
        duration = duration / 60;
        if(duration < 18) {
            this.showFeeDisclaimer = true;
        }else{
            this.showFeeDisclaimer = false;
        }
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/modal-recurrency.component.ts